<div class="root">
  <div>
    <my-lateral-menu [config]="menuConfig"></my-lateral-menu>
  </div>

  <div class="flex-grow-1">
    <router-outlet></router-outlet>
  </div>
</div>
